(function () {
    'use strict';
    angular.module('emarket.commons').directive('mdSocialButton', ['$state', '$auth', function ($state, $auth) {
        return {
            restrict: "EA",
            scope: {
                network: '@'
            },
            link: function (scope, element, attr) {
                element.on('click', function () {
                    $auth.authenticate(scope.network).then(function () {
                        $state.go('main.home');
                    });
                });
            },
            templateUrl: 'directives/social-button/md-social-button.tpl.html'

        };
    }]);
}());
